// @flow

// Helper functions
const iconsHelper = {
  'Afsendt Mail': 'ico-6',
  'Ubesvaret': 'ico-5',
  'Afventer kontakt': 'ico-1',
  'Opfølgning / Mødebooking': 'ico-8',
  'Tilbud sendt': 'ico-6',
  'Ikke tid': 'ico-1',
  'Vundet emne': 'ico-4',
  'Tabt emne': 'ico-7',
  'Emnet er ikke interesseret': 'ico-3',
  'Afsendt SMS': 'ico-2',
  'Optaget': 'ico-5',
  'Forkert nummer': 'ico-7',
  'match': 'ico-1',
  'success': 'ico-2',
  'reject': 'ico-3',
  'Bruger rykker for kontakt': 'ico-9'
}

export default iconsHelper;



// WEBPACK FOOTER //
// ./src/helpers/icons.helper.js